import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const inputCls = "w-full bg-panel border border-line focus:border-white outline-none px-3 py-2 text-sm text-white";

const PasswordChanger = ({ token, onFlash }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    if (form.next.length < 8) {
      setError("Le nouveau mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (form.next !== form.confirm) {
      setError("Les deux nouveaux mots de passe ne correspondent pas.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/admin/change-password", { current_password: form.current, new_password: form.next }, token);
      onFlash("Mot de passe mis à jour");
      setForm({ current: "", next: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      setError(formatApiErrorDetail(err.message));
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button
        data-testid="admin-password-button"
        onClick={() => setOpen(true)}
        className="border border-line px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-300 hover:text-white hover:border-white transition-colors"
      >
        Mot de passe
      </button>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4" data-testid="admin-password-modal">
      <div className="w-full max-w-md border border-line bg-coal p-6 sm:p-8">
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-display font-bold uppercase tracking-wider text-lg text-white">Changer le mot de passe</h3>
          <button data-testid="admin-password-close" onClick={() => setOpen(false)} className="font-mono text-sm text-neutral-400 hover:text-white" aria-label="Fermer">✕</button>
        </div>
        <div className="space-y-4">
          <input type="password" data-testid="admin-password-current" placeholder="Mot de passe actuel" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} className={inputCls} />
          <input type="password" data-testid="admin-password-new" placeholder="Nouveau mot de passe (8 caractères min.)" value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} className={inputCls} />
          <input type="password" data-testid="admin-password-confirm" placeholder="Confirmer le nouveau mot de passe" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className={inputCls} />
          <button data-testid="admin-password-submit" onClick={submit} disabled={busy} className="w-full bg-white text-ink font-mono text-[11px] uppercase tracking-[0.2em] py-3.5 hover:bg-gold disabled:opacity-50 transition-colors">
            {busy ? "Mise à jour…" : "Mettre à jour"}
          </button>
          {error && <p className="font-mono text-xs text-red-400" data-testid="admin-password-error">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default PasswordChanger;
